import React, { useState } from "react";

export default function Slider({ data }) {
  const [state, setstate] = useState(() => data?.[0] || "");
  return (
    <div className="slider">
      <div className="thumbnail">
        {data?.map((item) => {
          return (
            <div className="px-2" onClick={() => setstate(item)} key={item}>
              <div
                className={[
                  "item bg-gray-100",
                  state === item ? "selected" : "",
                ].join(" ")}
              >
                <img
                  src={item}
                  alt={item}
                  className="object-cover w-full h-full rounded-lg"
                />
              </div>
            </div>
          );
        })}
      </div>
      <div className="preview">
        <div className="item bg-gray-100 rounded-lg h-full overflow-hidden">
          <img
            src={state}
            alt={state}
            className="object-cover w-full h-full rounded-lg"
          />
        </div>
      </div>
    </div>
  );
}
